import * as React from 'react';
import { LocationViewModel } from '../../model/LocationViewModel'
import { CustomGrid, ColumnDefinition } from '../common/customGrid/CustomGrid';
import TranslatedMessage from '../translations/TranslatedMessage';

interface ILocationGridProps {
  locations: LocationViewModel[];
  onLocationClick: (id: string) => void;
  onAddClick: (event: any) => void;
}

class LocationGrid extends React.Component<ILocationGridProps> {
  private columnsDefinitions: Array<ColumnDefinition<LocationViewModel>> = [
    { columnKey: "locationName", columnLabel: <TranslatedMessage id="location.field.name" />, cellValue: (((_) => _.name)) },
    { columnKey: "street", columnLabel: <TranslatedMessage id="location.field.street" />, cellValue: (((_) => _.street)) },
    { columnKey: "zipCode", columnLabel: <TranslatedMessage id="location.field.zipCode" />, cellValue: (((_) => _.zipCode)) },
    { columnKey: "city", columnLabel: <TranslatedMessage id="location.field.city" />, cellValue: (((_) => _.city)) },
    { columnKey: "canton", columnLabel: <TranslatedMessage id="location.field.canton" />, cellValue: (((_) => _.canton)) },
    { columnKey: "contactName", columnLabel: <TranslatedMessage id="location.field.contactName" />, cellValue: (((_) => _.contactName)) },
    { columnKey: "contactPhoneNo", columnLabel: <TranslatedMessage id="location.field.contactPhoneNo" />, cellValue: (((_) => _.contactPhoneNo)) },
    { columnKey: "contactEmailAddress", columnLabel: <TranslatedMessage id="location.field.contactEmailAddress" />, cellValue: (((_) => _.contactEmailAddress)) },
    { columnKey: "languageRegions", columnLabel: <TranslatedMessage id="location.field.languageRegions" />, cellValue: (((_) => _.languageRegions && _.languageRegions.join(', '))) },
  ];

  public render() {
    return (
      <CustomGrid<LocationViewModel>
        columnDefinitions={this.columnsDefinitions}
        rows={this.props.locations}
        onRowClick={(_) => this.props.onLocationClick(_.id)}
        rowKey={(_) => _.id}
        addButtonTooltip={<TranslatedMessage id="location.button.new" />}
        onAddClick={this.props.onAddClick}
      />
    );
  }
}

export default LocationGrid;
